import { render } from "./scoreBoard.vue?vue&type=template&id=0c2b2275"
import script from "./scoreBoard.vue?vue&type=script&lang=js"
export * from "./scoreBoard.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__